import { createAPI } from '@common'
export default {
  getAdminStorages: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60benjo0tupsbhft', 'get', config),
  postAdminStorages: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60benjo0tupsbhft', 'post', config),
  putAdminStorages: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60benjo0tupsbhft', 'put', config),
  deleteAdminStorages: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0f60benjo0tupsbhft', 'delete', config),
  getSysStorages: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.sftpvsdf0tzt0tupsbhf', 'get', config)
}
